import { render, staticRenderFns } from "./PromotionRow.vue?vue&type=template&id=e32d7ce6&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./PromotionRow.vue?vue&type=script&lang=ts"
export * from "./PromotionRow.vue?vue&type=script&lang=ts"
import style0 from "./PromotionRow.vue?vue&type=style&index=0&id=e32d7ce6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32d7ce6",
  null
  
)

export default component.exports